import { cva } from 'class-variance-authority';

export const searchInputVariants = cva(
  'flex items-center gap-2 w-full rounded-md border transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 font-["DM_Sans"] text-base',
  {
    variants: {
      state: {
        enabled:
          'bg-card border-border text-gray-400 placeholder:text-gray-400 focus-within:border-primary focus-within:text-gray-700',
        filled: 'bg-card border-gray-500 text-gray-700',
        error: 'bg-card border-red-600 text-gray-700',
        disabled: 'bg-accent border-border text-gray-400 cursor-not-allowed',
      },
      size: {
        default: 'h-10 fhd:h-11 px-2 py-2 fhd:px-3',
        sm: 'h-9 fhd:h-10 px-2 py-1.5 fhd:px-2.5',
        lg: 'h-11 fhd:h-12 px-3 py-2.5 fhd:px-4',
      },
    },
    defaultVariants: {
      state: 'enabled',
      size: 'default',
    },
  },
);
